module.exports = __webpack_public_path__ + "static/media/SF-3-if-wrong.9285bb8d.mp3";